import { useRecordContext } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import { Chip, Link, Stack, Typography } from '@mui/material';
import type { AdminUserAccess } from '@rekindle/shared/types/adminSubscription';
import { PLAN_TIER_CHIP_COLORS, PLAN_TIER_LABELS } from '../../constants';
import { SubscriptionAccess, SubscriptionSource } from '../subscriptions/SubscriptionFields';
import { useAdminText } from '../shared/useAdminText';

export function PartnerLink({ partner }: { partner: AdminUserAccess['partner'] | undefined }) {
  const t = useAdminText();
  return partner ? <Link component={RouterLink} to={`/users/${partner.id}/show`} onClick={event => event.stopPropagation()} underline="hover">
    {partner.name || partner.email}
  </Link> : <Typography variant="body2" color="text.secondary">{partner === null ? t('noPartner', 'No linked partner') : t('partnerUnavailable', 'Partner unavailable')}</Typography>;
}

export function PartnerField() {
  return <PartnerLink partner={useRecordContext()?.partner} />;
}

export function EffectivePlanField() {
  const access = useRecordContext()?.effectiveSubscription as AdminUserAccess['effectiveSubscription'] | undefined;
  return access ? <Chip label={PLAN_TIER_LABELS[access.planTier]} color={PLAN_TIER_CHIP_COLORS[access.planTier]} size="small" variant="outlined" /> : <span>—</span>;
}

export function EffectiveSourceField() {
  const record = useRecordContext(), t = useAdminText();
  const access = record?.effectiveSubscription as AdminUserAccess['effectiveSubscription'] | undefined;
  return access?.source === 'partner'
    ? <Stack spacing={0.5}><Chip size="small" variant="outlined" label={t('fromPartner', 'From partner')} /><PartnerLink partner={record?.partner} /></Stack>
    : <SubscriptionSource value={access?.access} />;
}

export function EffectiveAccessField() {
  return <SubscriptionAccess value={useRecordContext()?.effectiveSubscription?.access} />;
}
